export default __webpack_public_path__ + "static/media/Img0005.d756be7d.png";